import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#da4444',
        },
        secondary: {
            main: '#19857b',
        },
        background: {
            default: '#fff',
        },
    },
});

export default theme;